import { useState } from "react";
import Link from "next/link";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";
import CustomAccordion from "@/src/lib/ui/customAccordion";

const AnnualReturn = ({ title, content }) => {
    const [expanded, setExpanded] = useState(false);
    return (
        <CustomAccordion
            title={title}
            open={expanded}
            setOpen={setExpanded}
            onClick={() => setExpanded(!expanded)}
            className="bg-primary/5 mb-4 hover:shadow-lg transition-shadow duration-300 ease-in-out shadow"
            buttonClassName={`hover:bg-primary/10 hover:text-white ${
                expanded ? "bg-primary/10" : ""
            }`}
        >
            <div className="flex flex-col justify-between bg-white -m-4 p-4">
                {content.map((item) => (
                    <div
                        className="flex flex-row justify-between items-center border-b border-solid border-primary/20 md:py-4 py-2 last:border-b-0 last:pb-0 first:pt-0"
                        key={item.uploadName}
                    >
                        <p className="text-black font-medium md:text-base text-sm">
                            {item.uploadName}
                        </p>
                        <Link
                            target="_blank"
                            href={`${NEXT_IMAGE_CDN}/${item.objectKey}`}
                            className="text-white bg-primary hover:bg-primary/80 transition-all duration-300 md:px-4 px-2 py-1.5 rounded md:text-sm text-xs"
                        >
                            View Details
                        </Link>
                    </div>
                ))}
            </div>
        </CustomAccordion>
        // <Accordion className="shadow bg-primary/5 mb-4">
        //     <AccordionSummary
        //         expandIcon={<CustomExpandIcon />}
        //         aria-controls={`specialization-content-${title}`}
        //         id={`specialization-header-${title}`}
        //         className="text-primary font-medium capitalize tracking-wider py-1"
        //     >
        //         {title}
        //     </AccordionSummary>

        //     <AccordionDetails className="md:mt-0 bg-white p-4 border-t border-solid border-primary/20">
        //         <div className="flex flex-col justify-between">
        //             {content.map((item) => (
        //                 <div
        //                     className="flex flex-row justify-between items-center border-b border-solid border-primary/20 md:py-4 py-2 last:border-b-0 last:pb-0 first:pt-0"
        //                     key={item.uploadName}
        //                 >
        //                     <p className="text-black font-medium md:text-base text-sm">
        //                         {item.uploadName}
        //                     </p>
        //                     <Link
        //                         target="_blank"
        //                         href={`${NEXT_IMAGE_CDN}/${item.objectKey}`}
        //                         className="text-white bg-primary hover:bg-primary/80 transition-all duration-300 md:px-4 px-2 py-1.5 rounded md:text-sm text-xs"
        //                     >
        //                         View Details
        //                     </Link>
        //                 </div>
        //             ))}
        //         </div>
        //     </AccordionDetails>
        // </Accordion>
    );
};

export default AnnualReturn;
